import React from "react";

interface WhySubscribeProps {
	description?: string;
	list: string[];
}

export function WhySubscribe({ description, list }: WhySubscribeProps) {
	let bullets: React.ReactNode;

	if (list) {
		bullets = (
			<ol>
				{list.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ol>
		);
	}

	return (
		<section className="section--why-subscribe">
			<div className="container grid">
				<div className="img-wrapper grid__col-12 grid__col-md-6">
					<figure>
						<img
							src="/static/img/product/why-subscribe.jpg"
							alt=""
						/>
					</figure>
				</div>
				<div className="typography grid__col-12 grid__col-md-6">
					<p className="section-title">
						Why subscribe to our
						<br /> news
					</p>
					{description && (
						<p className="section-description">{description}</p>
					)}
					{bullets}
				</div>
			</div>
		</section>
	);
}
